import { Modal } from "react-bootstrap";
import { TwilioNumber } from "../../configs";

type Props = {
  conferenceTin: string;
  show: boolean;
  handleShow: (value: boolean) => void;
};

export function ModalLobbyAudioCallData(props: Props): JSX.Element {
  return (
    <Modal show={props.show} onHide={() => props.handleShow(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Join and use a phone for audio</Modal.Title>
      </Modal.Header>
      <Modal.Body>
            <div className="row">
              <div className="form-group col-md-12">
                <label htmlFor="" className="text-muted font-sz-12">
                  On your phone, dial
                </label>
              </div>
              <div className="form-group col-md-12">
                <label htmlFor="" className="text-muted font-sz-12">
                  {TwilioNumber.ivrNumberForVideoConference}
                </label>
              </div>
              <div className="form-group col-md-12">
                <label htmlFor="" className="text-muted font-sz-12">
                  Enter this pin, when prompted
                </label>
              </div>
              <div className="form-group col-md-12">
                <label htmlFor="" className="text-muted font-sz-12">
                  {props?.conferenceTin}
                </label>
              </div>
            </div>

            <div
              className="row 
                justify-content-lg-end justify-content-xl-end justify-content-md-end justify-content-sm-center justify-content-center 
                flex-column flex-sm-column flex-md-row flex-lg-row flex-xl-row
                mx-0"
            >
              <button
                className="  btn btn-outline-dark border-grey 
                  d-flex d-sm-flex d-md-inline-block d-lg-inline-block d-xl-inline-block 
                  flex-grow-1 flex-sm-grow-1 flex-xl-grow-0 flex-lg-grow-0 flex-md-grow-0 
                  justify-content-center align-items-center my-xl-0 my-lg-0 my-md-0 my-sm-2 my-2 "
                onClick={() => props.handleShow(false)}
              >
                Close
              </button>
            </div>
      </Modal.Body>
    </Modal>
  );
}
